import { useTranslation } from 'react-i18next';
import { Form } from '@/components';
import { ProjectDto } from '@/core';
import classes from './SheetFormInputs.module.scss';
import { useEpicsOptions, useTablesOptions } from './hooks';

type PropsType = {
  projectData: ProjectDto;
  handleChangePickedTables: (tables: string[]) => void;
  editedSheetId?: string;
};

export const SheetFormInputs = ({ projectData, handleChangePickedTables, editedSheetId = '' }: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const tablesOptions = useTablesOptions(projectData);
  const epicsOptions = useEpicsOptions(projectData, editedSheetId);

  return (
    <div className={classes.inputsWrapper}>
      <div className={classes.sheetNameInput}>
        <Form.Input
          label={false}
          name="name"
          allowClear
          required
          placeholder={t('addSheets.placeholder.name')}
        />
      </div>
      <div className={classes.tablesSelect}>
        <Form.Select
          mode="multiple"
          label={false}
          options={tablesOptions}
          name="tables"
          placeholder={t('addSheets.placeholder.tables')}
          required
          allowClear={false}
          onChange={handleChangePickedTables}
          maxTagCount="responsive"
        />
      </div>

      <div className={classes.epicsSelect}>
        <Form.Select
          mode="multiple"
          label={false}
          options={epicsOptions}
          name="epics"
          placeholder={t('addSheets.placeholder.epics')}
          required
          allowClear={false}
        />
      </div>
    </div>
  );
};
